export function clinicianInboxDestination(search: string) {
  return {
    pathname: '/clinician-portal',
    search,
  };
}

export function clinicianWorklistDestination(search: string) {
  return {
    pathname: "/clinician-portal/today",
    search,
  };
}
